module.exports = __webpack_public_path__ + "media/images/countryrect/pl-2b7475b20031b5597b5e3d409106ead7.svg";